import { shouldInfluencerFillBankDetails, shouldInfluencerFillBusinessDetails } from 'utils/organization';
import { getAgencyIdForOrganization } from 'utils/navigation';

import { InfluencerProfile, OrganizationSettings } from 'types';

type OrganizationsDictionary = {
  [x: number]: { agencyOrganizationId?: number, influencerProfiles?: Array<InfluencerProfile> }
};

export const getSettingsUrl = (
  organizationId: number | null,
  organizations: OrganizationsDictionary
): string | null => {
  if (organizationId === null) {
    return null;
  }

  const organization = organizations[organizationId];

  if (!organization) {
    return null;
  }

  const agencyId = getAgencyIdForOrganization(organization);

  return agencyId && !organization?.influencerProfiles?.length ?
    `/agency/${agencyId}/settings/details` :
    `/organizations/${organizationId}/settings/details`;
};

export const getMissingPaymentInfo = (
  organizationSettings?: OrganizationSettings
): 'all' | 'bank' | 'business' | 'none' => {
  if (!organizationSettings) {
    return 'all';
  }

  const lackingBankDetails = shouldInfluencerFillBankDetails(organizationSettings);
  const lackingBusinessdetails = shouldInfluencerFillBusinessDetails(organizationSettings);

  if (lackingBankDetails && lackingBusinessdetails) {
    return 'all';
  }

  if (lackingBusinessdetails) {
    return 'business';
  }

  if (lackingBankDetails) {
    return 'bank';
  }

  return 'none';
};

export const isAccountActivated = (account: { activated?: boolean } | null): boolean => (
  Boolean(account?.activated)
);
